<div class="content-wrapper">
    <div class="page-heading d-flex align-items-center gap-4">
      <h2>Latest Version: 2</h2>
      <p class="mb-0">Sections available: 3</p>
    </div>
    <div class="card">
      <div class="card-header">
        <h2 class="table-ttl">Available Versions:</h2>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Versions</th>
                <th>Sections</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let version of versionWithCount">
                <td>{{version.version}}</td>
                <td>{{version.sectionCount}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  